
<template>
  <div v-if="isResponsive"
    :class="['image-container', {'loaded': loaded}]" 
  >
    <transition name="fade">
      <img 
        @load="onLoad"
        class="lazy-image lazyload"
        :src="computedPlaceholder" 
        :data-src="computedSrc"
        :data-srcset="computedSrcset"
        :key="computedSrcset"
        sizes="auto"
        :alt="alt" 
      />
    </transition>
    <!-- <img 
      class="placeholder-image"
      :src="computedPlaceholder" 
      alt="placeholder for lazy-loaded image"
      :key="computedSrc"
    /> -->
  </div>
  <div v-else
    :class="['image-container', {'loaded': loaded}]" 
  >
    <img 
      class="basic-image"
      @load="onLoad"
      :src="computedSrc"
      :alt="alt"
    />
  </div>
</template>

<script>

export default {
  name: 'ResponsiveImage',
  props: {
    name: String,
    ext: String,
    ratio: {
      type: Number,
      default: 16/9, 
    }, 
    src: String,
    alt: String,
    isResponsive: Boolean,
    sizes: String,
    isLazy: Boolean,
    placeholderSrc: String, 
    fadeIn: Boolean, 
    fadeDelay: Number,
    enter: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      loaded: false,
      mounted: false, 
    }
  },
  computed: {
    srcName() {
      return this.src.split('.')[0];
    },
    computedSrc() {
      if (this.isResponsive) {
        return require(`../assets${this.srcName}-1440${this.ext}`);
      } else {
        return require(`../assets${this.src}`);
      }
    },
    computedSrcset() {
      const images = [
        [require(`../assets${this.srcName}-640${this.ext}`), '640w'], 
        [require(`../assets${this.srcName}-1024${this.ext}`), '1024w'],
        [require(`../assets${this.srcName}-1440${this.ext}`), '1440w'] 
      ]
      return `${images[0][0]} ${images[0][1]}, ${images[1][0]} ${images[1][1]}, ${images[2][0]} ${images[2][1]}`;
    },
    computedPlaceholder() {
      return require(`../assets${this.srcName}-60${this.ext}`);
    },
  },
  methods: {
    onLoad() {
      this.loaded = true
      this.$emit("content-loaded");
    },
  },
  mounted() {
    this.mounted = true
  },
}
</script>

<style lang="sass">

/////////////////////////////////////////////
// 
// Responsive Image
// 
/////////////////////////////////////////////
@import '../assets/partials/vars'

.image-container
  position: relative
  overflow: hidden

  img
    display: block
    width: 100%
    &.lazy-image
      transition: 100ms ease-in
      filter: blur(50px)
      transition-property: opacity, filter

    &.lazyloaded
      background: $primary-color
      filter: blur(0px)
      opacity: 1

  .placeholder-image
    opacity: 1

  .lazy-image
    max-width: 100%
    max-height: 100%
    // &[lazy=loaded] ~ .placeholder-image
      // opacity: 0
      // height: 0
      // width: 0


.fade-enter-active, .fade-leave-active
  transition: opacity 0.8s ease-in 3s

.fade-enter, .fade-leave-to   
  opacity: 0
</style>
